import { EmptyBoxSticker } from '@/assets/images';

export const NotFoundResult = () => {
  return (
    <div className="flex flex-col items-center justify-center bg-transparent overflow-y-auto h-[55vh] gap-6">
      <EmptyBoxSticker className="flex-shrink-0" />
      <span className="font-medium text-base text-neutral-n7">No results found.</span>
    </div>
  );
};
